import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";
import { Row, Col } from "react-flexbox-grid";

const styles = theme => ({
  paper: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 10
  },
  margin: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2
  }
});

class PaperContainer extends Component {
  render() {
    const { classes, title, children } = this.props;
    return (
      <div>
        <Paper className={classes.paper}>
          <Row>
            <Col xs={12}>
              <Typography
                variant="h5"
                component="h3"
                className={classes.margin}
              >
                {title}
              </Typography>
            </Col>
            <Col xs={12}>
              <Divider />
            </Col>
            <Col xs={12}>{children}</Col>
          </Row>
        </Paper>
      </div>
    );
  }
}

export default withStyles(styles)(PaperContainer);



// WEBPACK FOOTER //
// ./src/components/paper-container/index.js